<template>
  <div class="RequestAssignUserComponent">

    <b-form>
    
          <b-form-group :label="lang.label_Users+':'">
            <b-form-select v-model="userId" :options="usersList" size="sm" class="mt-3">
            </b-form-select>

          </b-form-group>
      

    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "RequestAssignUserComponent",
  components: {

    

  },
  props:{
    lang: Object,
    data: Object
  },
  data () {
    return {
            
      userId: null,
      usersList: [
        {
          value: null,
          text: "Choose a user..."
        }
      ],
    }
  },
  computed: {
    ...mapGetters({

      currentUser: 'currentUser',
      globalSettings: 'globalSettings'

    }),
    
  },
  created() {

    let vue = this;

    const obj = {
      requestId: this.requestId
    }
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_getUsersRequest", obj)
      .then((result) => {
        console.log(result.data)


        if (result.status == "OK") {
          vue.createUsersList(result.data);


        } else {

        }

      })


  },
  updated() {
    const obj = {
      userId: this.userId
    }
    this.$store.commit("SELECTASSIGNUSER", obj);
  },
  
  methods: {
    createUsersList(data) {

      for (let i = 0, lei = data.length; i < lei; i++) {
        

          const obj = {
            value: data[i].userId,
            text: data[i].login
          }
          
            this.usersList.push(obj);
          
          
        

      }

    }
  }
}
</script>
<style lang="scss">

  .RequestAssignUserComponent{

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/RequestAssignUserComponent.vue